import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

const getPosition = (position) => {
    switch (position) {
        case 'topLeft':
            return 'top-left';
        case 'topCenter':
            return 'top-center';
        case 'topRight':
            return 'top-right';
        case 'bottomLeft':
            return 'bottom-left';
        case 'bottomCenter':
            return 'bottom-center';
        case 'bottomRight':
            return 'bottom-right';
        default:
            return position;
    }
};

// rendered element, intended to be called like <ToastMessage ...props... />
export const ToastMessage = ({
    isOpen, // trigger to show toast msg.
    onClose, // action taken when toast "X" icon is clicked.

    title,
    width, // in %, using style:{}.
    position,
    duration, // in milliseconds
    //progressColor, // Can't change from here, progress bar color set in App.css. Set as default brand.darkBlue.
    className,
    style, //for extra styles required, using regular style={{}} format.
    children, //the actual contents/text of the message.
}) => {
    useEffect(() => {
        if (isOpen) {
            toast(
                <div className={`flex-1 w-full m-1 p-2 ${className}`} style={style}>
                    {title && <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{title}</div>}
                    {children}
                </div>,
                {
                    position: getPosition(position) || 'top-right',
                    autoClose: duration || 5000,
                    onClose: onClose,
                    style: {
                        width: width,
                        //background: '', //if a color ring around the message is wanted?
                    }
                }
            );
        }
    }, [isOpen, onClose, title, width, position, duration, className, style, children]);
    return null;
};

// simplified toast message, but less customization. Called like a function SimpleToast({...props...})
export const SimpleToast = ({ title, content }) => {
    toast(
        <div>
            {title && <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{title}</div>}
            <div>{content}</div>
        </div>,
        {
            position: 'top-right',
            autoClose: 3000,
            className: "bg-color-lightGrey border",
            style: { width: "100%", borderRadius: '10px' }
        }
    );
};

// also called like a function, but with more customization options.
export const CustomToast = ({
    title,
    content,
    width,
    position,
    duration,
    className,
    style,
    children,
}) => {
    toast(
        <div className={`flex-1 w-full m-1 p-2 bg-color-lightGrey border rounded-md ${className}`} style={style}>
            {title && <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{title}</div>}
            {children}
        </div>,
        {
            position: getPosition(position) || 'top-right',
            autoClose: duration || 3000,
            style: {
                width: width,
                //background: '', //if a color ring around the message is wanted?
            }
        }
    );
};

// Helper shortcuts for common toast types
CustomToast.success = (message, options = {}) =>
    toast.success(message, { position: getPosition(options.position) || 'top-right', autoClose: options.duration || 3000 });

CustomToast.error = (message, options = {}) =>
    toast.error(message, { position: getPosition(options.position) || 'top-right', autoClose: options.duration || 3000 });

CustomToast.info = (message, options = {}) =>
    toast.info(message, { position: getPosition(options.position) || 'top-right', autoClose: options.duration || 3000 });

CustomToast.warning = (message, options = {}) =>
    toast.warning(message, { position: getPosition(options.position) || 'top-right', autoClose: options.duration || 3000 });
